/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'

import type { Transaction } from '../model'

export const transactionDetailsDialogAtom = atom<
  Transaction.Transaction | undefined
>(undefined, 'transactionDetailsDialogAtom')

export const openTransactionDetailsDialogAction = action(
  (ctx, transaction: Transaction.Transaction) => {
    transactionDetailsDialogAtom(ctx, transaction)
  },
)
